import { ParseQuery } from './parse-query';

import { FileRef, Filter } from './../data';

export class FileRefQuery extends ParseQuery<FileRef> {
  constructor() {
    super(FileRef);
  }

  public filter(filter: Filter) {
    switch (filter.type) {
      case FileRef.PATH_KEY:
        if (filter.value) {
          this.equalTo(FileRef.PATH_KEY, filter.value);
        }
        break;
    }
    return this;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/file-ref-query.ts